import cx from 'classnames';
import pluralize from 'pluralize';
import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {TRANSLATION_KEYS} from 'locale';
import {transformUtils} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.MAX_USERS;

type Props = {
    maxUsers: number;
    unitPrice: number;
    currency: string;
    periodUnit: string;
    className?: string;
    size?: 'large' | 'medium';
}

export const TotalPrice: React.FC<Props> = ({maxUsers, unitPrice, currency, periodUnit, className, size = 'medium'}) => {
    const {t} = useTranslation();

    const renderTopLabel = useCallback(() => (
        <span className='tw-font-bold tw-mr-1 -sm:tw-block'>
            {`${t(T_KEYS.TOTAL_PRICE)}: ${transformUtils.formatPrice(maxUsers * unitPrice, currency)}`}
        </span>
    ), [maxUsers, unitPrice, currency, t]);

    const usersLabel = useMemo(() => pluralize(t(T_KEYS.USERS), maxUsers), [maxUsers, t]);

    const renderBottomLabel = useCallback(() => (
        <span className={cx('tw-ml-1', {
            'tw-text-2xl': size === 'large',
            'tw-text-sm': size === 'medium'
        })}
        >
            {`/ ${periodUnit} (x${maxUsers} ${usersLabel})`}
        </span>
    ), [size, maxUsers, usersLabel, periodUnit]);

    return (
        <div className={cx(className, {
            'tw-text-3xl': size === 'large'
        })}
        >
            {renderTopLabel()}
            {renderBottomLabel()}
        </div>
    );
};